
/** Represents a Date in the form YYYY-mm-DD */
export type IsoDate = string & { _isoString: string };

export function IsoDateString(str: string): IsoDate {
    return str as IsoDate;
}

export type IsoDateTime = string & { _isoDateTime: string };

export function IsoDateTimeString(str: string): IsoDateTime {
    return str as IsoDateTime;
}

export type OffsetDateTime = string & { __zoneDateTime: string };
